import { useEffect } from 'react';
import { siteInfo } from '@/mocks/tvSeries';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown>;
}

export default function SEO({
  title = `${siteInfo.name} - 电视剧全集、最新电视剧、热门剧集 | 国产剧韩剧美剧在线观看高清不卡即点即看`,
  description = '草民影院提供电视剧全集、最新电视剧、热门剧集，国产剧、韩剧、美剧在线观看，高清不卡，即点即看。',
  keywords = '电视剧全集,最新电视剧,热门剧集,国产剧,韩剧,美剧,在线观看,高清不卡,草民影院',
  canonicalUrl = 'https://caomin.tv',
  ogType = 'website',
  ogImage = '',
  schema,
}: SEOProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const canonicalEl = document.querySelector('link[rel="canonical"]');
    if (canonicalEl) {
      canonicalEl.setAttribute('href', canonicalUrl);
    }

    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl, true);
    if (ogImage) {
      setMeta('og:image', ogImage, true);
    }

    setMeta('twitter:title', title);
    setMeta('twitter:description', description);

    // JSON-LD
    if (schema) {
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        existingScript.remove();
      }
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    }

    return () => {
      // Cleanup on unmount - not strictly necessary since next page will override
    };
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, schema]);

  return null;
}